import Vue from "vue"
import VueI18n from "vue-i18n"
import router from "@/config/router"

Vue.use(VueI18n)

/* EN - ENGLISH */
import en_global from "@/languages/en"
import en_dashboard from "@/modules/dashboard/language/en"
import en_settings from "@/modules/settings/language/en"
import en_auth from "@/modules/auth/language/en"
import en_users from "@/modules/users/language/en"
import en_persons from "@/modules/persons/language/en"
import en_roles from "@/modules/roles/language/en"
import en_permissions from "@/modules/permissions/language/en"
import en_logs from "@/modules/logs/language/en"
import en_queues from "@/modules/queues/language/en"
import en_courses from "@/modules/courses/language/en"
import en_certificates from "@/modules/certificates/language/en"
import en_companies from "@/modules/companies/language/en"
import en_changelog from "../modules/changelog/language/en"

/* NO - NORWEGIAN */
import no_global from "@/languages/no"
import no_dashboard from "@/modules/dashboard/language/no"
import no_settings from "@/modules/settings/language/no"
import no_auth from "@/modules/auth/language/no"
import no_users from "@/modules/users/language/no"
import no_persons from "@/modules/persons/language/no"
import no_roles from "@/modules/roles/language/no"
import no_permissions from "@/modules/permissions/language/no"
import no_logs from "@/modules/logs/language/no"
import no_queues from "@/modules/queues/language/no"
import no_courses from "@/modules/courses/language/no"
import no_certificates from "@/modules/certificates/language/no"
import no_companies from "@/modules/companies/language/no"
import no_changelog from "../modules/changelog/language/no"

/* NN - NYNORSK */
import nn_global from "@/languages/nn"
import nn_dashboard from "@/modules/dashboard/language/nn"
import nn_settings from "@/modules/settings/language/nn"
import nn_auth from "@/modules/auth/language/nn"
import nn_users from "@/modules/users/language/nn"
import nn_persons from "@/modules/persons/language/nn"
import nn_roles from "@/modules/roles/language/nn"
import nn_permissions from "@/modules/permissions/language/nn"
import nn_logs from "@/modules/logs/language/nn"
import nn_queues from "@/modules/queues/language/nn"
import nn_courses from "@/modules/courses/language/nn"
import nn_certificates from "@/modules/certificates/language/nn"
import nn_companies from "@/modules/companies/language/nn"
import nn_changelog from "../modules/changelog/language/nn"

const locales = {
  en: {
    global: en_global,
    settings: en_settings,
    dashboard: en_dashboard,
    auth: en_auth,
    users: en_users,
    persons: en_persons,
    roles: en_roles,
    permissions: en_permissions,
    logs: en_logs,
    queues: en_queues,
    courses: en_courses,
    certificates: en_certificates,
    companies: en_companies,
    changelog: en_changelog,
  },

  no: {
    global: no_global,
    settings: no_settings,
    dashboard: no_dashboard,
    auth: no_auth,
    users: no_users,
    persons: no_persons,
    roles: no_roles,
    permissions: no_permissions,
    logs: no_logs,
    queues: no_queues,
    courses: no_courses,
    certificates: no_certificates,
    companies: no_companies,
    changelog: no_changelog,
  },

  nn: {
    global: nn_global,
    settings: nn_settings,
    dashboard: nn_dashboard,
    auth: nn_auth,
    users: nn_users,
    persons: nn_persons,
    roles: nn_roles,
    permissions: nn_permissions,
    logs: nn_logs,
    queues: nn_queues,
    courses: nn_courses,
    certificates: nn_certificates,
    companies: nn_companies,
    changelog: nn_changelog,
  }
}

let user = localStorage.getItem("__crrntUser")
let locale = "no"

if (user) {
  user = JSON.parse(user)

  if (user) {
    // HACK: IF THE SETTINGS IN THE LOCALSTORAGE IS NOT ARRAY, IT MEANS THAT THEIR SETTINGS IS NOT YET UPDATED, WILL DO FORCE LOGOUT
    if (!Array.isArray(user.settings)) {
      localStorage.removeItem("__crrntUser")
      router.push("/auth/no/login")
    } else {
      locale = user.settings.find((i) => i.key == "locale").value
    }
  }
}

export default new VueI18n({
  locale: "",
  fallbackLocale: "no",
  messages: locales,
  silentTranslationWarn: true
})
